// extracted by mini-css-extract-plugin
export default {"wrapper":"receiptEvent_wrapper__Z8p9+","table":"receiptEvent_table__sTN9z","table__head_row":"receiptEvent_table__head_row__U6UMI"};